import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { resubsribeSubscription } from '../../services/subscriptions';
import useGetSubscription from './useGetSubscription';
import { ROUTES } from '../../constants/global';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

interface ResubscribeSubscriptionOptions {
  onError?: (error?: AxiosError) => void | Promise<void>;
}

function useResubscribeSubscription({
  onError,
}: ResubscribeSubscriptionOptions = {}) {
  const { user } = useUser<LoadedUser>();
  const { data: { subscription } = {} } = useGetSubscription();

  const businessId = user?.business?.id;

  const resubscribeMutation = useMutation({
    mutationFn: async () => {
      if (!subscription || !businessId) return false;

      const { subscription: newSub } =
        (await resubsribeSubscription(subscription.id, businessId)) || {};
      if (!newSub) throw new Error('Cannot resubscribe');

      return newSub;
    },
    onSuccess: success => {
      if (success) {
        window.location.href = `${ROUTES.subscription}?success=true&method=resubscribe`;
      }
    },
    onError: error => {
      if (onError) onError(error as AxiosError);
    },
  });

  return {
    resubscribeMutation,
    isPending: resubscribeMutation.isPending,
    isSuccess: resubscribeMutation.isSuccess,
  };
}

export default useResubscribeSubscription;
